import {History} from 'history';
import * as I from 'immutable';
import React from 'react';

import {CenteredSpinner} from 'app/components/CenteredSpinner';
import {LayoutWrapper} from 'app/components/LayoutWrapper';
import {ApiOrganization, ApiOrganizationUser} from 'app/modules/Remote/Organization/types';
import {LoggedInAuth, LoggedInUserActions} from 'app/providers/AuthProvider';

import {AgentWorkflow} from './AgentWorkflow';
import {useAgentWorkflows, useFeaturesQuery} from './hooks';
import {RunView} from './RunView';

type Props = {
  workflowId: string;
  runId?: string;
  history: History;
  auth: LoggedInAuth;
  profile: I.ImmutableOf<ApiOrganizationUser>;
  organization: I.ImmutableOf<ApiOrganization>;
  loggedInUserActions: LoggedInUserActions;
};

export const AgentWorkflowSwitch: React.FC<Props> = ({
  workflowId,
  history,
  auth,
  profile,
  organization,
  loggedInUserActions,
  runId,
}) => {
  const {data: features, isFetching: isFetchingFeatures} = useFeaturesQuery(4243);
  const {data: workflows, isFetching: isFetchingWorkflows} = useAgentWorkflows(
    organization.get('id')
  );

  const selectedWorkflow = workflows?.find((w) => w.id === workflowId);

  let content;
  if (isFetchingFeatures || isFetchingWorkflows) {
    content = (
      <div style={{width: '100%', height: '100%'}}>
        <CenteredSpinner />
      </div>
    );
  } else if (!workflows || !features) {
    content = <div>No workflows or features found.</div>;
  } else if (runId && selectedWorkflow) {
    content = <RunView workflow={selectedWorkflow} runId={runId} features={features} />;
  } else if (selectedWorkflow) {
    content = <AgentWorkflow workflow={selectedWorkflow} features={features} history={history} />;
  } else {
    content = <div>Workflow with ID {workflowId} not found.</div>;
  }

  return (
    <LayoutWrapper
      history={history}
      auth={auth}
      profile={profile}
      organization={organization}
      loggedInUserActions={loggedInUserActions}
    >
      {content}
    </LayoutWrapper>
  );
};
